import type { IconSize } from '@/components/Icon/Icon.types';

import type { FlagCountryCode } from './CountryFlagIcon.types';

import * as S from './CountryFlagIcon.styles';

export interface CountryFlagIconProps {
  country: FlagCountryCode;
  round?: boolean;
  size: IconSize;
}

export const CountryFlagIcon = ({
  country,
  round = true,
  size,
}: CountryFlagIconProps) => {
  return (
    <S.Wrapper round={round} size={size}>
      <span
        aria-label={`${country}-icon`}
        className={`fi-${country} fis`}
        data-testid='country-flag-icon'
      />
    </S.Wrapper>
  );
};

CountryFlagIcon.displayName = 'CountryFlagIcon';
